export default __webpack_public_path__ + "static/media/beQI.75302259.svg";